import "./PaymentModel.scss";
import Modal from "react-bootstrap/Modal";
import * as Yup from "yup";
import ErrorText from "../errorText/ErrorText";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { LuArrowRight } from "react-icons/lu";
import { Fragment, useState } from "react";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import { baseUrl, sponserPaymentEndPoint } from "../../utils/apiData";
import { images } from "../../utils/images";

const PaymentModel = (props) => {
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const [step, setStep] = useState(0);
  const [data, setData] = useState({});

  const submitPaymentApi = async (body) => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${sponserPaymentEndPoint}`, {
        ...body,
      });
      if (res?.data?.success) {
        setSuccess(true);
        setLoader(false);
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const initialValues = {
    name: "",
    mobile: "",
    email: "",
    amount: "",
    upi_id:"",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Field is required!"),
    email: Yup.string()
      .email("invalid email formate!")
      .required("Field is required!"),
    mobile: Yup.number().required("Field is required!"),
    amount: Yup.number().required("Field is required!"),
  });

  const onSubmit = (values) => {
    setData(values);
    setStep(1);
  };

  const [utrNum, setUtrNum] = useState("");
  const [error, setError] = useState(false);

  const formSubmitApi = (e) => {
    e.preventDefault();
    if (utrNum) {
      submitPaymentApi({ ...data, utr_number: utrNum });
    } else {
      setError(true);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="sponser_model"
    >
      <Modal.Body>
        {success ? (
          <div className="success_screen">
            <div className="btn_line">
              <button type="button" onClick={props.onHide}>
                <IoMdClose />
              </button>
            </div>
          <h4>Thank you for your support</h4>
          </div>
        ) : (
          <div className="form_wrap">
            <div className="btn_line">
              <button type="button" onClick={props.onHide}>
                <IoMdClose />
              </button>
            </div>
            {step === 0 && <h4>Let’s grow the game together</h4>}
            {step === 1 && <h4>Please Scan below QR Code & Pay</h4>}

            {step === 0 && (
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                <Form>
                  <div className="field">
                    <label htmlFor="Name">Name</label>
                    <Field
                      type="text"
                      placeholder="Your name"
                      id="Name"
                      name="name"
                      autoComplete="off"
                    />
                    <ErrorMessage name="name" component={ErrorText} />
                  </div>

                  <div className="field">
                    <label htmlFor="Phone">Mobile</label>
                    <Field
                      type="number"
                      placeholder="Your phone"
                      id="Phone"
                      name="mobile"
                      autoComplete="off"
                    />
                    <ErrorMessage name="mobile" component={ErrorText} />
                  </div>
                  <div className="field">
                    <label htmlFor="Email">Email</label>
                    <Field
                      type="email"
                      placeholder="Your Email"
                      id="Email"
                      name="email"
                      autoComplete="off"
                    />
                    <ErrorMessage name="email" component={ErrorText} />
                  </div>
                  <div className="field">
                    <label htmlFor="amount">Amount</label>
                    <Field
                      type="number"
                      placeholder="Enter Amount"
                      id="amount"
                      name="amount"
                      autoComplete="off"
                    />
                    <ErrorMessage name="amount" component={ErrorText} />
                  </div>

                  <div className="field">
                    <label htmlFor="upiId">UPI Id</label>
                    <Field
                      type="text"
                      placeholder="Please enter UPI Id"
                      id="upiId"
                      name="upi_id"
                      autoComplete="off"
                    />
                  </div>

                  <button type="submit" className="main_btn">
                    Submit <LuArrowRight />
                  </button>
                </Form>
              </Formik>
            )}

            {step === 1 && (
              <div className="qr_wrap">
                <div className="img_wrap">
                  <img src={images.qrCode} alt="Qr Code" />
                </div>
                <p className="my-3">
                  Or Pay using Google pay number : <span>+91 96989 82827</span>
                </p>
                <div className="line"></div>
                <form onSubmit={formSubmitApi}>
                  <p className="yellow">
                    Once payment is successful please enter your UTR number /
                    UPI Transaction ID :
                  </p>
                  <div className="field">
                    <label htmlFor="Name">UPI Transaction ID</label>
                    <input
                      type="text"
                      value={utrNum}
                      placeholder="Enter UPI Transaction ID"
                      onChange={(e) => {
                        setUtrNum(e.target.value);
                        setError(false);
                      }}
                    />

                    {error && (
                      <p className="text-danger">Please Enter UTR Number</p>
                    )}
                  </div>

                  <button type="submit" className="main_btn">
                    {loader ? "Loading..." : "Submit"}
                    {!loader && <LuArrowRight />}
                  </button>
                </form>
              </div>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PaymentModel;
